// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.github-signIn-link {
    color: white;
    margin-right: 2em;
    text-decoration: none;
    font-size: 14px;
    text-transform: uppercase;
    font-family: 'Open Sans' !important;
}

.github-signIn-link:hover {
    color: white;
    font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/navigation/NavBar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB","sourcesContent":[".github-signIn-link {\n    color: white;\n    margin-right: 2em;\n    text-decoration: none;\n    font-size: 14px;\n    text-transform: uppercase;\n    font-family: 'Open Sans' !important;\n}\n\n.github-signIn-link:hover {\n    color: white;\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
